"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.DomestikaLiveCardInfo = void 0;

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _react = _interopRequireDefault(require("react"));

var _FeaturedLiveInfo = require("./FeaturedLiveInfo");

var _CompleteLiveInfo = require("./CompleteLiveInfo");

var _BasicLiveInfo = require("./BasicLiveInfo");

var _Layout = require("../Layout");

var LiveCardInfoTypes = {
  featured: function featured(props) {
    return _react.default.createElement(_FeaturedLiveInfo.FeaturedLiveInfo, props);
  },
  complete: function complete(props) {
    return _react.default.createElement(_CompleteLiveInfo.CompleteLiveInfo, props);
  },
  basic: function basic(props) {
    return _react.default.createElement(_BasicLiveInfo.BasicLiveInfo, props);
  }
};

var DomestikaLiveCardInfo = function DomestikaLiveCardInfo(_ref) {
  var type = _ref.type,
      props = (0, _objectWithoutProperties2.default)(_ref, ["type"]);
  return _react.default.createElement(_Layout.Flex, {
    flexDirection: "column",
    maxWidth: "100%"
  }, LiveCardInfoTypes[type](props));
};

exports.DomestikaLiveCardInfo = DomestikaLiveCardInfo;
DomestikaLiveCardInfo.defaultProps = {
  streamers: [],
  liveInfo: {},
  liveLabel: '',
  type: 'complete',
  size: 'large',
  fontColor: 'light'
};